import { Helmet } from 'react-helmet-async';
import KeywordBased from 'src/sections/overview/dashboards/views/keywordBased';

export default function BrandShieldKoBiddingManualTcpa() {
  return (
    <>
      <Helmet>
        <title>Target CPA</title>
      </Helmet>

      <KeywordBased />
    </>
  );
}
